import styled from 'styled-components'

interface TableTagProps {
  bgColor?: string
  background?: string
  color?: string
  borderRadius?: number
  style?: React.CSSProperties
  children: React.ReactNode
  title?: string
}
export const TableTag = (props: TableTagProps) => <Tab {...props}>{props.children}</Tab>

const Tab = styled.div<TableTagProps>`
  display: inline-block;
  border-radius: ${props => props.borderRadius || 4}px;
  padding: 4px 6px;
  font-size: 12px;
  font-weight: 400;
  color: ${props => props.color};
  background: ${props => props.background};
  border: ${props => (props.bgColor ? `1px solid ${props.bgColor}` : '')};
  cursor: default;
  line-height: 1.2;
`
